<template>
  <div id="mr-footer">
    <div class="app-footer">
      <div class="app-footer__inner">
        <div class="app-footer__inner__col onassis">
          <div class="col-heading">
            PRODUCED
          </div>
          <a class="col-link"
             href="https://www.onassis.org/"
             target="_blank"
          >
            <img :src="onassisImage" />
          </a>
<!--          <div class="demos-desktop">-->
<!--            <div class="col-heading">-->
<!--              SEND YOUR DEMOS-->
<!--            </div>-->
<!--            <a class="col-link-mail" href="mailto:info@stegi.radio">-->
<!--              info@stegi.radio-->
<!--            </a>-->
<!--          </div>-->
        </div>
        <div v-if="isMailChimpActive" class="app-footer__inner__col mail">
          <div class="col-heading">
            SUBSCRIBE
          </div>
          <div class="col-subscribe">
            <BaseMailForm />
          </div>
        </div>
        <div class="app-footer__inner__col half-left">
          <div class="col-heading">
            FOLLOW
          </div>
          <ul class="col-list">
            <li v-for="item in configRoutes.socialRoutes"
                :key="item.id"
                class="col-list__item"
            >
              <a class="col-list__item__link"
                 :href="item.routePath"
                 target="_blank"
              >
                {{ item.routeName }}
              </a>
            </li>
          </ul>
        </div>
        <div class="app-footer__inner__col half-right">
          <div class="col-heading">
            MENU
          </div>
          <ul class="col-list">
            <li v-for="item in configRoutes.navRoutes"
                :key="item.id"
                class="col-list__item"
            >
              <router-link class="col-list__item__link" :to="{ path: item.routePath }">
                {{ item.routeName }}
              </router-link>
            </li>
          </ul>
        </div>
<!--        <div class="app-footer__inner__col mobile">-->
<!--          <div class="col-heading">-->
<!--            SEND YOUR DEMOS-->
<!--          </div>-->
<!--          <a class="col-link-mail" href="mailto:info@stegi.radio">-->
<!--            info@stegi.radio-->
<!--          </a>-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import configRoutes from '../router/configRoutes';
import onassisImage from '@/assets/logos/onassis-stegi-official-black-inline.svg';
import BaseMailForm from '@/components/ui/BaseMailForm.vue';
export default {
  name: 'MrFooter',
  components: {
    BaseMailForm
  },
  data: () => ({
    configRoutes: configRoutes,
    onassisImage: onassisImage,
    isMailChimpActive: false
  }),
  mounted() {
    this.getMailChimpStatus();
  },
  methods: {
    getMailChimpStatus() {
      axios
        .get(this.$router.options.api + '/front/is-mail-subscription-active')
        .then(response => (this.isMailChimpActive = response.data.active))
        .catch(error => console.error(error));
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/components/_app-footer.scss';
</style>
